// Quantity Selector

document.querySelector('.plus-input').addEventListener('click', () => {
  let currentValue = Number(document.querySelector('#qty').value);
  document.querySelector('#qty').value = currentValue + 1;
});

document.querySelector('.minus-input').addEventListener('click', () => {
  let currentValue = Number(document.querySelector('#qty').value);

  if (currentValue > 1) {
    document.querySelector('#qty').value = currentValue - 1;
  }
});

// Accordion

var acc = document.querySelectorAll(".accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
  
    // Loop over all the panels an close each one
    document.querySelectorAll(".panel").forEach(function(panel){
      panel.style.maxHeight = "0";
      panel.previousElementSibling.classList.remove("active");
    });
  
    // Then show the clicked panel
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      panel.style.maxHeight = panel.scrollHeight + "px";

  });
}
// First always open
  // document.addEventListener( 'DOMContentLoaded', function () {
  //   acc[0].click();
  // });


// RABBIT HOLE CAKES

// Tabs for Ingredients/Shipping
function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontents");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}
// Get the element with id="defaultOpen" and click on it
// document.getElementById("defaultOpen").click();